/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voice_MaleInputs */

const en_settings_voice_male = /** @type {(inputs: Settings_Voice_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Male`)
};

const es_settings_voice_male = /** @type {(inputs: Settings_Voice_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masculino`)
};

/**
* | output |
* | --- |
* | "Male" |
*
* @param {Settings_Voice_MaleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voice_male = /** @type {((inputs?: Settings_Voice_MaleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voice_MaleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voice_male(inputs)
	return en_settings_voice_male(inputs)
});